var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 69,
    viewBox: "0 0 49 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 39.19C40.58 47.4 38.06 50.05 34.31 54.39C31.26 57.92 28.38 51.63 24.39 51.63C20.4 51.63 17.9 57.92 14.85 54.39C10.94 49.87 8.08997 47.19 6.58997 38.1",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.35 33.32C42.45 32.51 42.54 31.71 42.6 30.97C43.49 20.93 35.51 12.38 24.62 19.01C11.03 12.54 6.70997 20.8 6.63997 30.97L4.39997 32.96C4.39997 32.96 2.55997 26.15 1.25997 19.27C0.519966 15.31 2.41997 11.73 4.78997 10.83C8.01997 9.59 12.6 7.18 16.15 2.68L19.22 5.09L19.55 1.03L26.91 4.43L27.9 1.58C27.9 1.58 33.58 7.48 41.79 9.6C43.4 10.02 47.14 11.47 47.14 17.18C47.14 21 46.56 26 45.05 31.05L42.35 33.33V33.32Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46999 32.72C-0.100009 37.01 2.33999 46.07 7.59999 43.34",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.41 32.54C49.11 36.76 46.67 46.1 41.34 43.33",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 48.17V51.15C42.2 60.98 34.23 67.96 24.39 67.96C14.55 67.96 6.58002 60.99 6.58002 51.15V47.4",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioMale);
export default __webpack_public_path__ + "static/media/radio-male.271de43dc0dd2b13599ef344bef5b01d.svg";
export { ForwardRef as ReactComponent };